<template lang="pug">
Layout(:header-bgc="true")
  template(slot="page")
    .container
      .price
        .price-item(v-for="price in priceData", :class="price.icon")
          .price-header
            h3 {{price.title}}
            p(v-for="desc in price.desc") {{desc}}
          .price-body
            ul
              li(v-for="feature in price.feature")
                span(:style="feature.support || delStyle")
                 | {{feature.type}}
                span(v-if="feature.content")
                 | （{{feature.content}}）
            p.cost
              span(v-for="price in price.price") {{price}}
          .price-footer
            a(href="http://console.oncdp.com/#/login",target="_blank") 立即购买
</template>

<script>
import Layout from '../components/layout'

export default {
  name: 'price',
  data() {
    return {
      priceData: [
        {
          icon: 'free',
          title: '免费版',
          desc: ['小微企业、非盈利性的个人网站', '博客等'],
          feature: [
            { type: '接入 CDN 服务商', support: true, content: '2 家' },
            { type: '智能调度', support: true, content: '电信、联通、移动' },
            { type: '超融合', support: false },
            { type: '自动容灾', support: false },
            { type: 'API', support: false },
            { type: '报警检测', support: false },
            { type: '短信通知', support: false },
            { type: '邮件通知', support: true },
            { type: '技术支持', support: false }
          ],
          price: ['免费']
        }, {
          icon: 'enterprise',
          title: '标准版',
          desc: ['适合具有一定访问规模的企业网站，', '例如企业门户、教育、娱乐等'],
          feature: [
            { type: '接入 CDN 服务商', support: true, content: '3 家' },
            { type: '智能调度', support: true, content: '运营商+省份' },
            { type: '超融合', support: true },
            { type: '自动容灾', support: false },
            { type: 'API', support: false },
            { type: '报警检测', support: false },
            { type: '短信通知', support: false },
            { type: '邮件通知', support: true },
            { type: '技术支持', support: true, content: '7*24 / QQ' }
          ],
          price: ['99 元/月', '999 元/年']
        }, {
          icon: 'ultimate',
          title: '企业版',
          desc: ['适合中、大型企业，例如电商、视频、', '游戏、金融、跨国企业网站等'],
          feature: [
            { type: '接入 CDN 服务商', support: true, content: '不限' },
            { type: '智能调度', support: true, content: '运营商+省份+海外' },
            { type: '超融合', support: true },
            { type: '自动容灾', support: true },
            { type: 'API', support: true },
            { type: '报警检测', support: true },
            { type: '短信通知', support: true },
            { type: '邮件通知', support: true },
            { type: '技术支持', support: true, content: '7*24 / QQ' }
          ],
          price: ['599 元/月', '5999 元/年']
        }
      ]
    }
  },
  computed: {
    delStyle() {
      return {
        textDecoration: 'line-through',
        color: '#b8b8b8'
      }
    }
  },
  components: { Layout }
}
</script>

<style lang="sass" scoped>
.container
  width: 1170px
  min-height: 100%
  margin: 0 auto

.price
  display: flex
  padding-top: 155px
  padding-bottom: 170px
  justify-content: space-around

.price-item:not(:first-child)
  margin-left: 80px

.price-item
  border-radius: 5px
  box-sizing: border-box
  border: 1px solid #18bbfe
  width: 314px
  text-align: center
  &:hover
    box-shadow: 0 1px 20px rgba(24,187,254, 0.2)
  &::before
    content: ''
    position: absolute
    width: 36px
    height: 36px
    transform: translateX(-50%) translateY(-50%)
    border-radius: 50%
    background-color: #2d8cf0
    background-repeat: no-repeat
    background-position: center
    background-size: 22px 22px
    z-index: 2
  &.free::before
    background-image: url('../assets/price/plan_free.svg')
  &.enterprise::before
    background-image: url('../assets/price/plan_enterprise.svg')
  &.ultimate::before
    background-image: url('../assets/price/plan_ultimate.svg')

.price-body
  text-align: left
  ul
    padding-left: 40px
    padding-top: 14px
    padding-bottom: 18px
    font-size: 14px
    line-height: 2
    color: #666666
    list-style: none

.cost
  font-size: 18px
  margin-bottom: 24px
  color: #00a0ff
  display: flex
  padding-left: 40px
  padding-right: 40px
  justify-content: space-between

.price-header
  padding-top: 20px
  text-align: center
  h3
    font-size: 16px
    margin-top: 15px
    margin-bottom: 5px
    font-weight: normal
    color: #333333
  p
    font-size: 14px
    color: #999999
    line-height: 1.6
  &:after
    content: ""
    display: block
    margin-top: 20px
    margin-left: 5px
    margin-right: 5px
    border-top: 1px solid #18bbfe

.price-footer
  a
    box-sizing: border-box
    text-decoration: none
    display: block
    height: 48px
    width: 100%
    background: #18bbfe
    color: #fff
    font-size: 18px
    text-align: center
    padding-top: 12px
    cursor: pointer
    transition: all 0.4s ease-in
    &:hover
      background-color: #0191e7
</style>



// WEBPACK FOOTER //
// price.vue?572ded5a